import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Row, Col, Card } from "react-bootstrap";
import { ApiUrl } from "../../../ApiUrl";

const AdmBookDashboard = () => {
  const [statsData, setStatsData] = useState(null);
  const [recentBookMovements, setRecentBookMovements] = useState([]);

  useEffect(() => {
    fetch(`${ApiUrl.apiurl}LibraryStatistics/`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch library statistics: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        if (data && data.data) {
          setStatsData(data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching library statistics:", error);
      });
  }, []);

  useEffect(() => {
    const fetchRecentBookMovements = async () => {
      try {
        const academicYearId = localStorage.getItem("academicSessionId");
        if (!academicYearId) {
          setRecentBookMovements([]);
          return;
        }

        const issueUrl = `${ApiUrl.apiurl}LIBRARYBOOK/GetIssueReturnSearchList?academic_year_id=${academicYearId}&flag=I`;
        const returnUrl = `${ApiUrl.apiurl}LIBRARYBOOK/GetIssueReturnSearchList?academic_year_id=${academicYearId}&flag=R`;

        const [issueResponse, returnResponse] = await Promise.all([
          fetch(issueUrl),
          fetch(returnUrl),
        ]);

        const issuePayload = await issueResponse.json();
        const returnPayload = await returnResponse.json();

        const issueRows = Array.isArray(issuePayload?.data)
          ? issuePayload.data.map((item) => ({
              bookName: item.bookName || "N/A",
              borrower: item.studentName || "N/A",
              type: "Issue",
              issueDate: item.issueDate || "N/A",
              returnDate: item.returnDate || "N/A",
              status: item.returnDate ? "Returned" : "Issued",
              sortDate: item.issueDate || "1970-01-01",
            }))
          : [];

        const returnRows = Array.isArray(returnPayload?.data)
          ? returnPayload.data.map((item) => ({
              bookName: item.bookName || "N/A",
              borrower: item.studentName || "N/A",
              type: "Return",
              issueDate: item.issueDate || "N/A",
              returnDate: item.returnDate || "N/A",
              status: "Returned",
              sortDate: item.returnDate || item.issueDate || "1970-01-01",
            }))
          : [];

        const topTen = [...issueRows, ...returnRows]
          .sort((a, b) => new Date(b.sortDate) - new Date(a.sortDate))
          .slice(0, 10)
          .map(({ sortDate, ...rest }) => rest);

        setRecentBookMovements(topTen);
      } catch (error) {
        console.error("Error fetching recent book movements:", error);
        setRecentBookMovements([]);
      }
    };

    fetchRecentBookMovements();
  }, []);

  const cards = statsData
    ? [
        {
          label: "Members",
          value: statsData.totalMembers,
          sub: "Total No Of Members",
          bg: "#e0f7fa",
          icon: "👥",
        },
        {
          label: "Students",
          value: statsData.totalMembersBreakdown?.students ?? 0,
          sub: "No Of Students",
          bg: "#f1f8e9",
          icon: "🎓",
        },
        {
          label: "Teachers",
          value: statsData.totalMembersBreakdown?.staff ?? 0,
          sub: "No Of Teachers",
          bg: "#ede7f6",
          icon: "👨‍🏫",
        },
        {
          label: "Books",
          value: statsData.totalBooks,
          sub: "Total No Of Books",
          bg: "#e8f5e9",
          icon: "📚",
        },
        {
          label: "Titles",
          value: statsData.totalTitles,
          sub: "Total No Of Titles",
          bg: "#fff3e0",
          icon: "📖",
        },
        {
          label: "Books Issued",
          value: statsData.totalBookIssues,
          sub: "Total No Of Books Issued",
          bg: "#ffebee",
          icon: "📕",
        },
        {
          label: "Books Returned",
          value: statsData.totalBooksReturned,
          sub: "Total No Of Books Returned",
          bg: "#e3f2fd",
          icon: "➕",
        },
      ]
    : [];

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                BOOK DASHBOARD
              </p>

              <div className="row mb-2 mt-3 mx-0">
                <Row className="mt-3 mb-4 justify-content-center">
                  {cards.map((item, idx) => (
                    <Col
                      key={idx}
                      className="mb-3 d-flex justify-content-center"
                    >
                      <Card
                        style={{
                          backgroundColor: item.bg,
                          width: "150px",
                          height: "150px",
                        }}
                      >
                        <Card.Body className="text-center d-flex flex-column justify-content-center align-items-center p-2">
                          <div
                            style={{ fontSize: "30px", marginBottom: "5px" }}
                          >
                            {item.icon}
                          </div>
                          <h6 style={{ fontSize: "14px", margin: "2px 0" }}>
                            {item.value}
                          </h6>
                          <p style={{ fontSize: "12px", margin: 0 }}>
                            {item.sub}
                          </p>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>

              <div className="row">
                <div className="col-12 mb-3">
                  <h6 style={{ fontWeight: 700 }}>
                    Recent Top 10 Issue / Return Books
                  </h6>
                  <div className="table-responsive">
                    <table className="table table-bordered table-striped mb-0">
                      <thead>
                        <tr>
                          <th>Sr.No</th>
                          <th>Book Name</th>
                          <th>Borrower</th>
                          <th>Type</th>
                          <th>Issue Date</th>
                          <th>Return Date</th>
                          <th>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {recentBookMovements.length > 0 ? (
                          recentBookMovements.map((item, index) => (
                            <tr key={`${item.bookName}-${item.borrower}-${index}`}>
                              <td>{index + 1}</td>
                              <td>{item.bookName}</td>
                              <td>{item.borrower}</td>
                              <td>{item.type}</td>
                              <td>{item.issueDate}</td>
                              <td>{item.returnDate}</td>
                              <td>{item.status}</td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No recent issue/return records found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="col">
                  <img
                    src="/Assets/library.jpg"
                    alt="library"
                    className="img-fluid"
                    style={{
                      width: "100%",
                      height: "500px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmBookDashboard;
